const navFunc = (() => {

  let nav = document.getElementById('jsNav');
  let navBtn = document.getElementById('jsNavBtn');
  let navLink = nav.querySelectorAll('.js-ul-t a');

  navBtn.addEventListener('click', (event) => {
    event.preventDefault();
    event.stopPropagation();
    if (navBtn.classList.contains('act') == true) {
      nav.classList.remove('act');
      navBtn.classList.remove('act');
    } else {
      nav.classList.add('act');
      navBtn.classList.add('act');
    }
  });

  for (let i = 0; i < navLink.length; i++) {
    navLink[i].addEventListener('click', () => {
      nav.classList.remove('act');
      navBtn.classList.remove('act');
    });
  }

})();
export default navFunc;